import { render, staticRenderFns } from "./HelpSupport.vue?vue&type=template&id=a3c26b24&scoped=true"
import script from "./HelpSupport.vue?vue&type=script&lang=js"
export * from "./HelpSupport.vue?vue&type=script&lang=js"
import style0 from "./HelpSupport.vue?vue&type=style&index=0&id=a3c26b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c26b24",
  null
  
)

export default component.exports